import React, { createContext, useContext, useLayoutEffect } from 'react';
import './AdminDesign.css';
const AdminDesignContext = createContext(false);
export const useAdminDesign = () => useContext(AdminDesignContext);
export default function AdminDesignScope({ children }: { children: React.ReactNode }) {
    useLayoutEffect(() => {
        document.body.setAttribute('data-admin-design', 'plan');
        return () => { document.body.removeAttribute('data-admin-design'); };
    }, []);
    return <AdminDesignContext.Provider value={true}><div className="admin-surface">{children}</div></AdminDesignContext.Provider>;
}
